import { ReducersTypes } from "constants/ReducersTypes";
import moment from "moment";

// Date range initial state - past 30 days
export const dateRange = {
  fromDate: moment().subtract(30, "days").format("MM/DD/YYYY"),
  toDate: moment().format("MM/DD/YYYY"),
};

// Column order for remote deposit batches table
export const REMOTE_DEPOSIT_BATCHES_COLUMN_ORDER = [
  "Batch Number",
  "Deposit Date",
  "Status",
  "Total Amount",
  "Number of Transactions",
];

export const REMOTE_DEPOSIT_BATCHES_COLUMNS = {
  "Original Name": true,
  "Deposit Account Number": true,
  Status: true,
  "Declared Total Amount": true,
  "Deposit Tracking Number": true,
  "Payment Date": true,
};

// Query params that drive the API call for batches
const initialRemoteDepositBatchesFilters = {
  ...dateRange,
  status: "",
  depositAccountNumber: "",
  depositTrackingNumber: "",
  page: 1,
  sortBy: "uploaded_at",
  sortOrder: "desc",
  perPage: 20,
};

// Query params that drive the API call for items
const initialRemoteDepositItemsFilters = {
  checkNumber: "",
  payerAccountNumber: "",
  page: 1,
  sortBy: "id",
  sortOrder: "desc",
  perPage: 20,
};

// Metadata returned by the API (not used as effect dependency)
const initialRemoteDepositPagination = {
  nextNum: null,
  prevNum: null,
  pages: null,
  total: null,
};

// Initial state
const initialRemoteDepositState = {
  loading: false,
  // Batches
  remoteBatches: [],
  batchesFilters: { ...initialRemoteDepositBatchesFilters },
  batchesPagination: { ...initialRemoteDepositPagination },
  batchDetails: {},
  // Items
  remoteItems: [],
  itemsFilters: { ...initialRemoteDepositItemsFilters },
  itemsPagination: { ...initialRemoteDepositPagination },
  itemDetails: {},
  // Upload
  uploadResponse: {},
};

/**
 * Remote deposit reducer
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} New state
 */
const remoteDepositState = (state = initialRemoteDepositState, action) => {
  switch (action.type) {
    case ReducersTypes["SET_REMOTE_DEPOSIT_BATCHES"]:
      return {
        ...state,
        remoteBatches: action.payload,
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_PAGINATION"]:
      return {
        ...state,
        batchesPagination: { ...state.batchesPagination, ...action.payload },
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_BATCHES_FILTERS"]:
      return {
        ...state,
        batchesFilters: { ...state.batchesFilters, ...action.payload },
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_BATCH_DETAILS"]:
      return {
        ...state,
        batchDetails: action.payload,
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_ITEMS"]:
      return {
        ...state,
        remoteItems: action.payload,
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_ITEMS_PAGINATION"]:
      return {
        ...state,
        itemsPagination: { ...state.itemsPagination, ...action.payload },
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_ITEMS_FILTERS"]:
      return {
        ...state,
        itemsFilters: { ...state.itemsFilters, ...action.payload },
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_ITEM_DETAILS"]:
      return {
        ...state,
        itemDetails: action.payload,
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_LOADING"]:
      return {
        ...state,
        loading: action.payload,
      };

    case ReducersTypes["SET_REMOTE_DEPOSIT_UPLOAD_RESPONSE"]:
      return {
        ...state,
        uploadResponse: action.payload,
      };

    default:
      return state;
  }
};

export default remoteDepositState;
